module.exports = __webpack_public_path__ + "static/media/Newsreader-Italic-VariableFont_opsz,wght.98587e79.ttf";